import React from 'react';
import { IconType } from 'react-icons/lib';
import { BotaoAcao } from '.././../../../shared/components/botao_acao';
import { Container } from './styles';

interface Acao {
  label: string;
  icone: IconType;
  visivel: boolean;
  cor: string;
  cor_texto: string;
  onClick: () => void;
}

interface Props {
  acoes: Acao[];
}

const ColunaAcoes: React.FC<Props> = (props) => {
  return (
    <Container>
      {props.acoes.map(
        (acao, index) =>
          acao.visivel && (
            <BotaoAcao key={index} onClick={acao.onClick} cor={acao.cor} descricao={acao.label}>
              <acao.icone color={acao.cor_texto} size={14} />
            </BotaoAcao>
          )
      )}
    </Container>
  );
};

export { ColunaAcoes };
export type { Acao };
